export default {
  xs: 1,
  sm: 40, // 688px
  md: 61.25, // 1080px
  lg: 90, // 1440px
  xl: 120, // 1920px
}
